module.exports = __webpack_public_path__ + "static/img/home_fn_content_07.af1dd0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_fn_content_07.png
// module id = SURx
// module chunks = 34